import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ValidationMessage } from "src/app/api/app-response.model";
import { FieldValidationError, ValidationError } from "src/app/model/validator/validator";
import { ValidatorService } from "src/app/service-utils/validator-service";

@Component({
    selector: 'app-validation-error',
    templateUrl: './validation-error.component.html',
    styleUrls: ['./validation-error.component.scss']
})
export class ValidationErrorComponent {

    @Input() form: FormGroup;
    @Input() controlName: string;
    @Input() messages: Array<ValidationMessage>;

    constructor(public validatorService: ValidatorService) { }

    gatherAllErrors(): Array<FieldValidationError> {
      let result = [];
      for(let control of Object.values(this.form.controls)) {
        if(control.errors) {
          result.push(...Object.values(control.errors));
        }
      }
      return result;
    }
}